<template>
  <InputTableContainer
    :loading="$apollo.loading"
    :headers="headers"
    :data="data"
    :actions="actions"
    :sortBy="sortBy"
    :sortDesc="sortDesc"
    type="delay"
  >
    <template v-slot:toolbar-right>
      <DelayCreateDropdown />
    </template>
  </InputTableContainer>
</template>

<script>
import { get } from 'vuex-pathify'
import { format } from 'date-fns'
import InputTableContainer from '@/components/InputTableContainer'
import DelayCreateDropdown from './DelayCreateDropdown'
import DelayEditModal from './DelayEditModal'
import DelayDeleteModal from './DelayDeleteModal'

export default {
  name: 'DelayContainer',

  components: {
    InputTableContainer,
    DelayCreateDropdown
  },

  data: () => ({
    actions: [
      {
        title: 'Redigera',
        icon: 'mdi-pencil',
        component: DelayEditModal,
        type: 'edit'
      },
      {
        title: 'Ta bort',
        icon: 'mdi-delete',
        component: DelayDeleteModal,
        type: 'delete'
      }
    ],
    sortDesc: false,
    sortBy: ['_location_time'],
    headers: [
      {
        text: 'Typ',
        value: 'type'
      },
      {
        text: 'Tågnr.',
        value: 'train_number'
      },
      {
        text: 'Plats',
        value: '_location_place'
      },
      {
        text: 'Platstid',
        value: '_location_time'
      },
      {
        text: 'Försening',
        value: 'delay'
      },
      {
        text: '',
        value: 'actions',
        sortable: false,
        filterable: false,
        align: 'right'
      }
    ]
  }),

  computed: {
    delays: get('delay/data'),
    stops: get('event/stops'),

    data() {
      const findLocationName = signature => {
        const location = this.stops.find(
          x => x.short_name === signature.toUpperCase()
        )
        return location ? location.stop_name : signature.toUpperCase()
      }
      return Object.values(this.delays).map(x => ({
        ...x,
        _location_place: findLocationName(x.location_place),
        _location_time: format(new Date(x.location_time), 'HH:mm')
      }))
    }
  },

  beforeDestroy() {
    this.$store.set('delay/data', {})
  }
}
</script>
